module.exports = __webpack_public_path__ + "img/WAREHOUSEANDFACTORY.93b3efc7.png";